import axios from 'axios';
import { IKitchensApi } from '../types/kitchen.types';
import { instance } from './instance';
import { stringifyParameters } from '../helpers';

const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;

export const kitchensApi: IKitchensApi = {
  getAllKitchenDeliveryConfig: async () =>
    (await instance.get('/admin/kitchen-delivery-config')).data.data,

  getAllKitchens: async (params) => {
    const queryParams = params?.skipTenantIsolation
      ? `?skipTenantIsolation=${params.skipTenantIsolation}`
      : '';
    return await instance.get(`/admin/kitchen/all/${queryParams}`);
  },

  getKitchen: async (id) => await instance.get(`/admin/kitchen/${id}/`),

  getKitchenBranches: async (id) =>
    await instance.get(`/kitchen/${id}/branches`),

  getKitchenBrands: async (id) => await instance.get(`/kitchen/${id}/brands`),

  getPlusCode: async (lat, lng) =>
    await axios.get(
      `https://plus.codes/api?address=${lat},${lng}&ekey=${apiKey}`,
    ),

  createKitchen: async (payload) =>
    await instance.post('/admin/kitchen/create/', payload),

  updateKitchen: async (payload, id) =>
    await instance.put(`/admin/kitchen/${id}/`, payload),

  deleteKitchen: async (id) => await instance.delete(`/admin/kitchen/${id}`),

  deleteKitchenStaff: async (kitchenId, staffId) =>
    await instance.delete(`/kitchen/${kitchenId}/staff/${staffId}`),

  inviteStaff: async (kitchenId, payload) =>
    await instance.post(`/kitchen/${kitchenId}/invites`, payload),

  updateStaff: async (kitchenId, userId, payload) =>
    await instance.put(`/kitchen/${kitchenId}/staff/${userId}`, payload),

  getKitchenRequests: async (params) => {
    const payload = stringifyParameters(params);

    const data = await instance.get(`/admin/kitchen-requests/all/${payload}`);

    return data.data;
  },

  getKitchenInvites: async (kitchenId) =>
    await instance.get(`/kitchen/${kitchenId}/invites`),

  resendInvite: async (kitchenId, inviteId) =>
    await instance.post(`/kitchen/${kitchenId}/invites/${inviteId}`),

  cancelInvite: async (kitchenId, inviteId) =>
    await instance.delete(`/kitchen/${kitchenId}/invites/${inviteId}`),

  approveKitchenRequest: async (code) =>
    (await instance.post(`/admin/kitchen-requests/${code}/approve`)).data,
};
